import React, { useState } from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { generateMercantileValue } from '../../../utils/generateMercantileValue';

enum StarState {
  EMPTY = '#FFFFFF',
  HALF = 'url(#smallHalf)',
  FILLED = '#000000',
}

const STAR_FILL_LIST_INIT = [
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
];

const SmallFiveStarRatingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextStyled = styled(Text)`
  color: #000000;
`;

interface FiveStarRatingProps {
  rating: number;
  isValueDisplayed?: boolean;
}

export const SmallFiveStarRating = (props: FiveStarRatingProps): React.ReactElement => {
  const { rating, isValueDisplayed } = props;
  const [starFillList, setStarFillList] = useState<string[]>(STAR_FILL_LIST_INIT);
  const [roundedRating, setRoundedRating] = useState<string>(generateMercantileValue(rating));
  React.useEffect(() => {
    if (rating) {
      const newStarFillList = [1, 2, 3, 4, 5].map((value) => {
        if (rating >= value - 0.25) {
          return StarState.FILLED;
        }
        if (rating >= value - 0.75) {
          return StarState.HALF;
        }
        return StarState.EMPTY;
      });
      setStarFillList(newStarFillList);
      setRoundedRating(generateMercantileValue(rating));
    }
  }, [rating]);
  if (rating && rating >= 0) {
    return (
      <SmallFiveStarRatingContainer>
        <svg style={{ width: 0, height: 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="smallHalf" x1="0" x2="100%" y1="0" y2="0">
              <stop offset="50%" stopColor="#000000" />
              <stop offset="50%" stopColor="#FFFFFF" />
            </linearGradient>
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13" id="smallStar">
              <path d="M6.126 1.5L7.71 4.7095L11.252 5.2245L8.689 7.7225L9.294 11.25L6.126 9.5845L2.958 11.25L3.563 7.7225L1 5.2245L4.542 4.7095L6.126 1.5Z" />
            </symbol>
          </defs>
        </svg>
        {starFillList.map((starState, index) => {
          return (
            // eslint-disable-next-line
            <span key={index} style={{ display: 'flex', marginRight: '2px' }}>
              <svg
                width="12"
                height="12"
                viewBox="-3 0 18 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.126 1.5L7.71 4.7095L11.252 5.2245L8.689 7.7225L9.294 11.25L6.126 9.5845L2.958 11.25L3.563 7.7225L1 5.2245L4.542 4.7095L6.126 1.5Z"
                  stroke="#000000"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                />
                <use href="#smallStar" fill={starState} />
              </svg>
            </span>
          );
        })}
        {isValueDisplayed && (
          <TextStyled variant={{ order: '2', style: 'normal', type: 'copy' }}>
            {roundedRating}
          </TextStyled>
        )}
      </SmallFiveStarRatingContainer>
    );
  }
  return <></>;
};
